<template>
  <div>
    <v-btn
        absolute top left
        color="primary"
        class="white--text"
        @click="navigateBack()">
        <v-icon large>mdi-chevron-left</v-icon>
    </v-btn>
    
    <div
      class="text-center mb-4"
      :class="$vuetify.breakpoint.xs ? 'text-h6 mt-4' : 'text-h5 mt-5'"
    >
        <v-icon :large="!$vuetify.breakpoint.xs">
            mdi-chart-line
        </v-icon>
        Egg Group
    </div>
    <div class="d-flex ml-5">
        <div class="mt-6 d-flex">
          <v-select
              v-model="selectedFarm"
              @change="farmSelected()"
              class="mr-6"
              style="max-width: 100px;"
              label="Farm"
                item-text="farmCode"
                item-value="farmCode"
              :items="farms"
          />
          <v-card class="justify-center pt-1 pr-0 pb-2 mb-4">
            <date-picker style="width:250px;"
              :open="pickerOpen"
              @confirm="applyPickerChanges"
              v-model="tempReportTimeRange"
              range
              confirm
              :editable="false"
              :clearable="false"
              :disabled-date="isPickerDateDisabled"
              placeholder="Select Date Range"
            >
              <div hidden slot="icon-calendar" />
              <div slot="input" :style="`font-size: 14px; background-color:${pickerColors.cardbackground}`">
                <div class="d-flex">
                  <v-btn class="mt-1 ml-2 mr-2" color="primary" @click="openPicker()"><v-icon>mdi-calendar</v-icon></v-btn>
                  <div style="padding: 2px 0 0 0">Uploaded Date Range:<br />{{convertDateToString(reportTimeRange[0])}} to {{convertDateToString(reportTimeRange[1])}}</div>
                </div>
              </div>
              <div slot="header" :style="`font-size: 16px; text-align:center; color: ${pickerColors.secondary}`">
                <b>Uploaded Date Range</b><br />
                <v-btn small @click="setPickerRange(7);" style="background-color: #1284E7; margin-top:10px; margin-right:25px">Last 7 Days</v-btn>
                <v-btn small @click="setPickerRange(14);" style="background-color: #1284E7; margin-top:10px; margin-right:25px">Last 14 Days</v-btn>
                <v-btn small @click="setPickerRange(28);" style="background-color: #1284E7; margin-top:10px; ">Last 28 Days</v-btn>
              </div>
              <div slot="footer" class="slot text-right mr-4 mb-2">
                <v-btn small :style="`color: white; background-color:${pickerColors.primary}`" @click="pickerApplyClicked()">Apply</v-btn>
                <v-btn small :style="`color: white; background-color:${pickerColors.secondary}; margin-left:10px`" @click="pickerOpen=false">Cancel</v-btn>
              </div>
            </date-picker>
          </v-card>
          <v-text-field
              class="pt-3 ml-5"
              v-model="searchGroups"
              clearable
              label="Search"
              type="text"
              prepend-icon="mdi-magnify"
          />
        </div>
    </div>
    <v-data-table
        class="mt-5 mx-4"
        fixed-header
        :search="searchGroups"
        :headers="lookupItemHeaders"
        :items="eggGroupList"
        no-data-text="No Data Available"
    >
        <template v-slot:[`item.deviceName`]="{ item }">
            <div class="text-caption d-inline-block text-truncate">
                {{ item.deviceName }}
            </div>
        </template>
        <template v-slot:[`item.clientUid`]="{ item }">
            <v-tooltip color="#7d92f5" bottom>
                <template v-slot:activator="{ on }">
                    <div v-on="on" class="text-caption d-inline-block text-truncate" style="max-width: 100px;">
                    {{ item.clientUid }}
                    </div>
                </template>
                <span>{{ item.clientUid }}</span>
            </v-tooltip>
        </template>
        <template v-slot:[`item.farm`]="{ item }">
            <div class="text-caption d-inline-block text-truncate">
                {{ item.farm }}
            </div>
        </template>
        <template v-slot:[`item.house`]="{ item }">
            <div class="text-caption d-inline-block text-truncate">
            {{ item.house }}
            </div>
        </template>
        <template v-slot:[`item.notes`]="{ item }">
            <v-tooltip color="#7d92f5" bottom>
                <template v-slot:activator="{ on }">
                    <div v-on="on" class="text-caption d-inline-block text-truncate">
                    {{ item.notes }}
                    </div>
                </template>
                <span>{{ item.notes }}</span>
            </v-tooltip>
        </template>
        <template v-slot:[`item.createDateTime`]="{ item }">
            <div class="text-caption  d-flex flex-wrap mx-3" style="max-width: 70px;">
            {{ item.createDateTime }}
            </div>
        </template>
        <template v-slot:[`item.uploadDateTime`]="{ item }">
            <div class="text-caption  d-flex flex-wrap mx-3" style="max-width: 70px;">
            {{ item.uploadDateTime }}
            </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
            <egg-action-buttons
            primary-button-icon="mdi-square-edit-outline"
            @primary-button-clicked="editEggGroup(item)"
            secondary-button-icon="mdi-trash-can-outline"
            @secondary-button-clicked="confirmDeleteEggGroup(item)"/>
        </template>
    </v-data-table>

    <v-dialog v-model="showChangeDialog"
      scrollable
      persistent
      max-width="800px"
    >
      <v-card>
        <v-card-title class="text-h5">
          Edit Egg Group
        </v-card-title>
        <v-card-text style="min-height: 400px; max-height:640px">
            <v-card class="pa-2">
                <v-row dense class="my-0">
                    <v-col class="text-left red--text">Farm</v-col>
                    <v-col class="text-left red--text">House</v-col>
                    <v-col cols="4" class="text-left red--text">Uid</v-col>
                    <v-col class="text-left red--text">Created</v-col>
                    <v-col class="text-left red--text">Uploaded</v-col>
                </v-row>
                <v-row dense class="my-0">
                    <v-col>{{ eggGroupToEdit.farm }}</v-col>
                    <v-col>{{ eggGroupToEdit.house }}</v-col>
                    <v-col cols="4">{{ eggGroupToEdit.clientUid }}</v-col>
                    <v-col>{{ eggGroupToEdit.createDateTime }}</v-col>
                    <v-col>{{ eggGroupToEdit.uploadDateTime }}</v-col>
                </v-row>
            </v-card>

            <v-data-table
              v-model="selectedRows"
              dense
              fixed-header
              show-select
              :search="searchEggs"
              :headers="eggItemHeaders"
              :items="eggGroupToEdit.samples"
              item-key="eggId"
              no-data-text="No Data Available">
              <template v-slot:top>
                <div class="mb-0 d-flex flex-wrap overflow-y-auto">
                  <v-text-field
                    class="mx-2 mt-1"
                    v-model="searchEggs"
                    clearable
                    label="Search"
                    type="text"
                    prepend-icon="mdi-magnify"
                  />
                  <v-btn :disabled="selectedRows.length == 0" @click="changeCollectionDateClicked()" class="mx-2 mt-3">Change Collection Date</v-btn>
                </div>
              </template>
              <template v-slot:[`item.badge`]="{ item }">
                <div>{{ item.badge }}</div>
              </template>
              <template v-slot:[`item.wingband`]="{ item }">
                <div>{{ item.wingband }}</div>
              </template>
              <template v-slot:[`item.operatorId`]="{ item }">
                <div>{{ getOperatorName(item.operatorId) }}</div>
              </template>
              <template v-slot:[`item.day`]="{ item }">
                <div>{{ item.day }}</div>
              </template>
               <template v-slot:[`item.time`]="{ item }">
                <div>{{ item.time }}</div>
              </template>
              <template v-slot:[`item.grade`]="{ item }">
                <div>{{ item.grade }}</div>
              </template>
            </v-data-table>
        </v-card-text>
        <egg-card-actions
          primary-button-text="Save"
          secondary-button-text="Cancel"
          @primary-button-clicked="saveEggGroup()"
          @secondary-button-clicked="selectedRows = []; showChangeDialog = false" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDeleteDialog" persistent max-width="350">
      <v-card>
        <v-card-title class="text-h5">
          Confirm Delete
        </v-card-title>
        <v-card-text>
            <v-icon class="mr-2">mdi-alert</v-icon>This DELETE action is PERMANENT.<br />
            Ok to Delete {{eggGroupToDelete.farm}}-{{eggGroupToDelete.house}} ({{eggGroupToDelete.clientUid}}) uploaded on {{eggGroupToDelete.uploadDateTime}}?
        </v-card-text>
        <egg-card-actions
          primary-button-text="Yes"
          secondary-button-text="No"
          @primary-button-clicked="deleteEggGroup()"
          @secondary-button-clicked="showDeleteDialog = false" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="showChangeDateDialog" persistent max-width="350">
      <v-card class="pa-5">
        <v-card-title class="text-h5">Collection Date</v-card-title>
        <v-card-text>
          <v-date-picker v-model="newCollectionDay" />
        </v-card-text>
        <egg-card-actions
          primary-button-text="Ok"
          secondary-button-text="Cancel"
          @primary-button-clicked="changeCollectionDate(); showChangeDateDialog=false"
          @secondary-button-clicked="showChangeDateDialog=false"
        />
      </v-card>
    </v-dialog>

    <v-overlay :value="pickerOpen">
    </v-overlay>
    <v-overlay :value="isBusy">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import ActionButtons from '@/components/ActionButtons'
import CardActions from '@/components/CardActions'
import eggApi from '../../api/eggApi'
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
  },
  async created() {
    this.selectedFarm = this.settings.currentFarm;

    let end = new Date();
    let start = new Date();
    start = new Date(start.setDate(start.getDate() - 14)) //back 2 weeks from today

    this.tempReportTimeRange = [start, end];
    this.reportTimeRange = [start, end];

    this.applyPickerChanges(); // Load groups for report time range
  },
  components: {
    'egg-action-buttons': ActionButtons,
    'egg-card-actions': CardActions,
    'date-picker' : DatePicker
  },
  data() {
    return {
      eggGroupList: [],
      eggGroupToEdit: {},
      eggGroupToDelete: {},
      searchGroups: '',
      searchEggs: '',
      showDeleteDialog: false,
      showChangeDialog: false,
      selectedFarm: null,
      isBusy: false,
      pickerColors: {
        primary: this.$vuetify.theme.themes.light.primary,
        secondary: this.$vuetify.theme.themes.light.secondary,
        cardbackground: this.$vuetify.theme.dark ? this.$vuetify.theme.themes.dark.cardbackground : this.$vuetify.theme.themes.light.cardbackground
      },
      pickerOpen: false,
      reportTimeRange: [],
      tempReportTimeRange:[],
      selectedRows: [],
      showChangeDateDialog: false,
      newCollectionDay: null
    }
  },
  computed: {
    ...mapState(['settings','isOnline']),
    farms() {
      return this.settings.farms.map(x=> x.farmCode);
    },
    lookupItemHeaders() {
      return [
        { text: 'Actions', value: 'action', sortable: false, align: 'center' },
        { text: 'Device Name', value: 'deviceName', sortable: true, align: 'left'},
        { text: 'Collection Uid', value: 'clientUid', sortable: true },
        { text: 'Farm', value: 'farm', sortable: true, align: 'center'},
        { text: 'House', value: 'house', sortable: true, align: 'left' },
        { text: 'Notes', value: 'notes', sortable: true, align: 'left' },
        { text: 'Dam', value: 'damEggCount', sortable: false, align: 'center' },
        { text: 'Nest', value: 'nestEggCount', sortable: false, align: 'center' },
        { text: 'Floor', value: 'floorEggCount', sortable: false, align: 'center' },
        { text: 'Created', value: 'createDateTime', sortable: true, align: 'center' },
        { text: 'Uploaded', value: 'uploadDateTime', sortable: true, align: 'center' },
      ];
    },
    eggItemHeaders() {
        return [
            { text: 'Badge', value: 'badge', sortable: true },
            { text: 'Wingband', value: 'wingband', sortable: true },
            { text: 'Operator', value: 'operatorId', sortable: true, align: 'left'},
            { text: 'Date', value: 'day', sortable: true, align: 'left' },
            { text: 'Time', value: 'time', sortable: true, align: 'left' },
            { text: 'Grade', value: 'grade', sortable: true, align: 'left' }
        ];
    }
  },
  methods: {
    ...mapActions(['updateSettingsInStore']),
    async applyPickerChanges() {
      try {
          this.isBusy = true;
          this.reportTimeRange = this.tempReportTimeRange;
          this.eggGroupList = await this.getEggGroups();
      }
      catch(error) {
        this.$root.showNoticeError(error.message);
      }
      finally{
        this.isBusy = false;
        this.pickerOpen = false;
      }
    },
    changeCollectionDate() {
      this.selectedRows.forEach(e => {
        e.day = this.newCollectionDay;
        e.date = e.day + "T" + e.time;
      });
    },
    changeCollectionDateClicked() {
      this.newCollectionDay = this.selectedRows[0].day;
      this.showChangeDateDialog = true;
    },
    confirmDeleteEggGroup(item) {
      this.eggGroupToDelete = item;
      this.showDeleteDialog = true;
    },
    convertDateToString(dt) {
      var formattedDate = dt.toISOString().slice(0, 10);
      return formattedDate;
    },
    async deleteEggGroup() {
      try {
        this.isBusy = true;
        await eggApi.deleteEggGroup(this.eggGroupToDelete.clientUid);
        this.eggGroupList = await this.getEggGroups();
        this.showDeleteDialog = false;
      }
      catch(error) {
        this.$root.showNoticeError(error.message);
      }
      finally{
        this.isBusy = false;
      }
    },
    async editEggGroup(item) {
      try {
        this.isBusy = true;
        var eggGroup = await eggApi.getEggGroups(this.selectedFarm, item.clientUid);
        this.eggGroupToEdit = eggGroup[0];
        this.eggGroupToEdit.samples.forEach(e => {
          e.day = e.date.split('T')[0];
          e.time = e.date.split('T')[1];
        });
        this.showChangeDialog = true;
      }
      catch(error) {
        this.$root.showNoticeError(error.message);
      }
      finally{
        this.isBusy = false;
      }
    },
    async farmSelected() {
      try {
          this.isBusy = true;
          this.eggGroupList = await this.getEggGroups();
      }
      catch(error) {
        this.$root.showNoticeError(error.message);
      }
      finally{
        this.isBusy = false;
      }
    },
    async getEggGroups() {
      var start = this.convertDateToString(this.reportTimeRange[0]);
      var end = this.convertDateToString(this.reportTimeRange[1]);
      var eggGroupList = await eggApi.getEggGroups(this.selectedFarm, null, start, end);
      return eggGroupList;
    },
    getOperatorName(id) {
      if (id == null) return '';
      let operator = this.settings.farmOperators.find(o => o.operatorId == id);
      let operatorName = "Unknown";
      if (operator) operatorName = operator.operatorName;
      return operatorName;
    },
    isPickerDateDisabled(dt) {
      let start = new Date ("2021-09-01");
      var end = new Date();
      end.setUTCHours(23,59,59,999);

      let isValidDate = start >= dt || dt >= end;
      return isValidDate;
    },
    navigateBack() {
      this.$router.go(-1);
    },
    openPicker() {
      this.pickerOpen = !this.pickerOpen;
      this.tempReportTimeRange = this.reportTimeRange;

      setTimeout( () => { // hide "OK" button
          var elem = document.getElementsByClassName('mx-datepicker-btn-confirm')[0];
          elem.style.display = "none";
        }, 100
      ); 
    },
    pickerApplyClicked() {
      var elem = document.getElementsByClassName('mx-datepicker-btn-confirm');
      elem[0].click(); //force picker to set tempReportTimeRange values
    },
    async saveEggGroup() {
      try {
        this.isBusy = true;
        await eggApi.updateEggGroup(this.eggGroupToEdit);
        this.showChangeDialog = false;
        this.selectedRows = [];
        this.eggGroupList = await this.getEggGroups();
      }
      catch(error) {
        this.$root.showNoticeError(error.message);
      }
      finally {
        this.isBusy = false;
      }
    },
    setPickerRange(days) {
      let end = new Date();
      let start = new Date();
      start = new Date(start.setDate(start.getDate() - days)) //back 2 weeks from today

      this.tempReportTimeRange = [start, end];
    }
  }
}
</script>